import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';
import store from '../../../store';
import enumObject from '@/shared-modules/modules/commit/commit.constants';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import qs from 'qs';

export default {
  getDifference(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/commit/diff`, { params })
      .then((res) => {
        store.dispatch('setCommitsDifference', res.data?.commitBlobModelList);
        store.dispatch('setCommitsLinesCounters', {
          addedLinesCount: res?.data?.addedLinesInAllFiles,
          removedLinesCount: res?.data?.removedLinesInAllFiles
        });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', {
          title: enumObject.COMMIT_COMPARE_ERRORS_ENUM[`${err.response.data.title}`]
        });
        throw err;
      });
  },
  getCommits(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/commit`, { params })
      .then((res) => {
        store.dispatch('setCommitGroups', res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getCommit(userAlias, projectAlias, commitId, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/commit/${commitId}`, { params })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getCommitCompareInfo(userAlias, projectAlias, commitId, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/commit/${commitId}/compare`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  createCherryPick(userAlias, projectAlias, branchName, data) {
    return axios
      .put(
        `/api/project/${userAlias}/${projectAlias}/branch/cherryPick?branchName=${branchName}`,
        data,
        {
          formName: FORM_NAME_ENUMS.CHERRY_PICK_FORM
        }
      )
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  revertCommit(userAlias, projectAlias, commitId, params) {
    return axios
      .post(
        `/api/project/${userAlias}/${projectAlias}/commit/${commitId}/revert`,
        qs.parse(params),
        { formName: FORM_NAME_ENUMS.COMMIT_REVERT_FORM }
      )
      .then((res) => {
        const MRStatus = Object.keys(res.data)[0];
        if (MRStatus !== 'MERGED') {
          smallNotification('danger', {
            title:
              MRStatus === 'CONFLICTS'
                ? 'Невозможно отменить, разрешите конфликты!'
                : 'Возникла ошибка при попытке отмены коммита!'
          });
          return false;
        }
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  },
  revertCommitWithNewMergeRequest(userAlias, projectAlias, commitId, params) {
    return axios
      .post(
        `/api/project/${userAlias}/${projectAlias}/commit/${commitId}/revert-with-mr`,
        qs.parse(params),
        {
          formName: FORM_NAME_ENUMS.COMMIT_REVERT_FORM
        }
      )
      .then((res) => res.data)
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  }
};
